<div class="position-relative">
  <app-navbar></app-navbar>
  <app-loading-general></app-loading-general>
  <app-user-access *ngIf="true" [isShowLogin]="!isUserAccessShow" [byPassEmailPasswordReset]="byPassEmailPasswordReset"></app-user-access>
  <app-user-onboarding [isShowPasswordEmailReset]="isShowPasswordEmailReset" [isShowPasswordReset]="isShowPasswordReset" [passwordKey]="passwordKey" [loginId]="loginId" [currentPassword]="currentPassword" [isShowCRUD]="isShowCRUD"></app-user-onboarding>
</div>
